import React, { useEffect, useState } from 'react'
import { IonAlert, IonAvatar, IonBackButton, IonBadge, IonButton, IonButtons, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonNote, IonPage, IonRow, IonSegment, IonSegmentButton, IonText, IonTitle, IonToggle, IonToolbar, isPlatform } from '@ionic/react'
import Api from "../../services/Api"
import dayjs from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import isoWeek from 'dayjs/plugin/isoWeek'
import weekday from 'dayjs/plugin/weekday';
import { caretBack, caretForward, people } from 'ionicons/icons'
import { goToPage } from '../../helpers/app_actions'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/reducers'

dayjs.extend(weekOfYear, isoWeek)
dayjs.extend(weekday)

const ChallengeLeaderboard = () => {
  const api = Api.getInstance()
  const me = useSelector((state: RootState) => state.logIn.user.person)
  const [challenges, setChallenges] = useState<Array<any>>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [currentWeek, setCurrentWeek] = useState<number>(dayjs().locale(api.lang).week())
  const [leaderboard, setLeaderboard] = useState<Array<any>>([])
  const [teams, setTeams] = useState({
    all: [] as Array<any>,
    org: [] as Array<any>
  })
  const [segment, setSegment] = useState<string | undefined>('average')
  const [checked, setChecked] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [mySteps, setMySteps] = useState({
    average: 0,
    steps: 0,
    group: [] as Array<any>
  })

  useEffect(() => {
    getWeek()
  }, [challenges])

  useEffect(() => {
    getWeek()
  }, [currentWeek])

  useEffect(() => {
    const org = filterOrg(teams.all)
    if(checked === true) {
      setLeaderboard(org)
    } else {
      setLeaderboard(teams.all)
    }
  },[checked || teams])

  useEffect(() => {
    api.get('pedometer/step_challenges_leaderboard').then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          return data.challenges
        }
      }).then(obj => {
        api.get('pedometer/step_challenges').then(res => {
          res.json().then(data => {
            if(data.status === 'ok') {
              const arr = []
              arr.push(...obj, ...data.challenges)
              // console.log(arr)
              setLoading(true)
              setChallenges(arr.filter((v: any, i: any, a: any) => a.findIndex((v2: any) =>(v2.id === v.id)) === i))
            }
          })
        })
      })
    })
  }, [])

  const getWeek = () => {
    let newArr: Array<any> = []
    for(let i = 0; i < 7; i++) {
      const day = dayjs().locale(api.lang).week(currentWeek).weekday(i).format('YYYY-MM-DD');
      newArr.push(day)     
    }
    getStepsEachWeek(newArr)
  }

  const getStepsEachWeek = (currentWeekdays: Array<any>) => {
    let activeTeam: Array<any> = []
    let teamGroup: Array<any> = []
    // console.log(challenges)
    challenges.forEach(chal => {
      const start = active(chal.start, chal.end, currentWeekdays[0])
      const end = active(chal.start, chal.end, currentWeekdays[6])
        if(start || end) {
          let newLeader = chal
          let myAverage = 0
          let mySteps = 0
          averageWeek(currentWeekdays, chal)
          
          currentWeekdays.forEach(days => {
            newLeader.weekSteps = 0
            newLeader.weekAverage = 0

            chal.persons.forEach((person:any) => {
              if(me.id === person.id) {
                newLeader.myTeam = true
                teamGroup.push(chal.group)
                
                person.stepsPerDay && person.stepsPerDay.forEach((day: any) => {
                  if(day.day === days) {
                    mySteps = Math.trunc(mySteps + day.steps)
                    myAverage = Math.trunc(mySteps / 7)
                  } 
                })
                setMySteps({
                  average: myAverage,
                  steps: mySteps,
                  group: [...new Set(teamGroup)]
                })
              } else {
                newLeader.myTeam = false
                newLeader.weekSteps = 0
                newLeader.weekAverage = 0
              }

              newLeader.weekSteps = Math.trunc(totalWeek(currentWeekdays, chal))
              newLeader.weekAverage = Math.trunc(averageWeek(currentWeekdays, chal))
            })
          })
        activeTeam.push(newLeader)                            
      }
    })

    if(checked === true) {
      const org = filterOrg(activeTeam)
      setLeaderboard(org)
    } else {
      setLeaderboard(activeTeam)
    }
    // setLeaderboard(activeTeam)
    setTeams({
      all: activeTeam,
      org: []
    })
  }

  const active = (dateFrom: any, dateTo: any, dateCheck: any) => {
    let from = Date.parse(dateFrom);
    let to   = Date.parse(dateTo);
    let check = Date.parse(dateCheck );

    if((check <= to && check >= from)) {
      return true
    } else {
      return false
    }
  }

  const filterOrg = (all: any) => {
    const org = mySteps.group.map((x) => { 
      const result = all.filter((y: any) => y.group === x);
      return result
    })  
    return org.length > 0 ? org[0] : [] 
  }

  const averageWeek = (currentWeekdays: Array<any>, challenge: any) => {
    let average = 0
    currentWeekdays.forEach(days => {
      challenge.persons.forEach((person:any) => {

        person.stepsPerDay && person.stepsPerDay.forEach((day: any) => {
          if(days === day.day) {
            average = average + day.steps
          }
        })
      })
    })
    return average / challenge.persons.length
  }

  const totalWeek = (currentWeekdays: Array<any>, challenge: any) => {
    let total = 0
    currentWeekdays.forEach(days => {
      challenge.persons.forEach((person:any) => {
        person.stepsPerDay && person.stepsPerDay.forEach((day: any) => {
          if(days === day.day) {
            total = total + day.steps
          }
        })
      })
    })
    return total 
  }

  return (
    <IonPage className="cheap_desktop">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton/>
          </IonButtons>
          <IonTitle>
            {api.tr('leaderboard')}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonToolbar>
          <IonLabel slot="end">{api.tr('my_orgs')}</IonLabel>
          <IonToggle 
            checked={checked}
            onIonChange={(e) => { 
              setChecked(e.detail.checked)
            }}
            slot="end" 
            className="p-2" 
            mode="ios"/>
        </IonToolbar>
        <IonToolbar className="text_center" >
          <IonButton 
            fill='clear'
            slot="start"
            onClick={() => setCurrentWeek(currentWeek - 1)}>
            <IonIcon icon={caretBack}/>
          </IonButton>
          <IonText>{api.tr('week')} {currentWeek}</IonText>
          { currentWeek === dayjs().locale(api.lang).week() ? 
            <IonButton
              disabled
              fill='clear'
              slot="end">
              <IonIcon icon={caretForward} color="medium"/> 
            </IonButton>
          : 
            <IonButton 
              fill='clear'
              slot="end" 
              onClick={() => setCurrentWeek(currentWeek + 1)}>
              <IonIcon icon={caretForward}/>
            </IonButton>
          }
        </IonToolbar>
        <IonToolbar className="fullWidth flex justify-center items-center">
          <IonSegment className="fullWidth" color="darkblue" value={segment} onIonChange={(e) => {
              setSegment(e.detail.value)
            }}>
            <IonSegmentButton className="m-2" value="average">{api.tr('team_average')}</IonSegmentButton>
            <IonSegmentButton className="m-2" value="steps">{api.tr('total_steps')}</IonSegmentButton>
          </IonSegment>
        </IonToolbar>
        {isPlatform('desktop') ? null :
        <IonGrid>
          <IonToolbar color="light" className="" onClick={() => goToPage('/walk/stepcounter')}>
            <IonRow className="p-2 m-2">
              <IonCol className="flex justify-center items-center">
                <IonText>{me.firstName}</IonText>
              </IonCol>
              <IonCol className="flex justify-center items-center">
                <IonAvatar>
                  <img src={me.picture} alt="user_image"/>
                </IonAvatar>
              </IonCol>
              <IonCol className="flex justify-center items-center">
              { segment === 'average' ? 
              <IonText>{api.tr('week_average')} {mySteps.average}</IonText> 
              :
              <IonText>{api.tr('total_steps')} {mySteps.steps}</IonText> 
              }
              </IonCol>
            </IonRow>
            <IonRow></IonRow>
          </IonToolbar>
        </IonGrid> }
        { segment === 'average' ? 
          <IonList>
            <IonListHeader className="p-2">
              <IonLabel><b>Team</b></IonLabel>
              <IonNote>{api.tr('week_team_average')}</IonNote>
            </IonListHeader>
            { loading && leaderboard.sort((a, b) => {
                return b.weekAverage - a.weekAverage;
              }).map((obj: any, index: any, key: any) => { 
                if(obj.persons.find((person: any) => person.id === me.id) !== undefined) {
                  obj.myTeam = true
                }
                // console.log(obj)
                return <IonItem 
                color={obj.myTeam ? 'light' : ''}
                onClick={() => {
                  if(obj.myTeam) {
                    goToPage('/walk/challenges/' + obj.id)
                  } else {
                    setOpenAlert(true)
                  }
                }}
                key={key + obj.id + obj.name}>
                <IonText slot="start" color="darkblue">#{index + 1}</IonText>
                <IonLabel className="ml-2">{obj.name}</IonLabel>
                <IonChip className="p-2" color="darkblue">
                  <IonIcon icon={people}/>
                  {obj.persons.length}
                </IonChip>
                <IonBadge color="darkblue" className="ml-2 p-2">{obj.weekAverage}</IonBadge>
              </IonItem>
              })
            }               
          </IonList>
        : 
          <IonList>
            <IonListHeader className="p-2">
              <IonLabel><b>Team</b></IonLabel>
              <IonNote>{api.tr('week_total_step')}</IonNote>
            </IonListHeader>
            { loading && leaderboard.sort((a, b) => {
                return b.weekSteps - a.weekSteps;
              }).map((obj:any, index: any, key:any) => {
                if(obj.persons.find((person: any) => person.id === me.id) !== undefined) {
                  obj.myTeam = true
                }
                // console.log(obj)
                return <IonItem 
                color={obj.myTeam ? 'light' : ''}
                onClick={() => {
                  if(obj.myTeam) {
                    goToPage('/walk/challenges/' + obj.id)
                  } else {
                    setOpenAlert(true)
                  }
                }}
                key={key + obj.id + obj.name}>
                <IonText slot="start" color="darkblue">#{index + 1}</IonText>
                <IonLabel className="ml-2">{obj.name}</IonLabel>
                <IonBadge color="darkblue" className="p-2">{obj.weekSteps}</IonBadge>
              </IonItem>
              })
            }
          </IonList>
        }
        { leaderboard.length === 0 ? <IonToolbar color="medium" className="text_center p-2">No active team this week</IonToolbar> : null }
      </IonContent>
      <IonAlert 
        isOpen={openAlert}
        header="Access denied"
        subHeader=""
        message="You can only access challenges you are an active member in."
        buttons={['OK']}
        onDidDismiss={() => setOpenAlert(false)}
        />
    </IonPage>
  )
}

export default ChallengeLeaderboard